import React from 'react';
import { useRouter } from 'next/router';
import styled from 'styled-components';
import ArrowLeft from 'src/assets/arrow-left';
import { KIOSK_PRO_MEDIA } from './kiosk-pro-shared.styles';

export function BackButton({ backRoute, className }: { backRoute?: string | null; className?: string }): JSX.Element {
  const router = useRouter();
  return (
    <BackButtonContainer onClick={() => (backRoute ? router.push(backRoute) : router.back())} className={className}>
      <ArrowLeft /> Back
    </BackButtonContainer>
  );
}

const BackButtonContainer = styled.button`
  position: absolute;
  z-index: 10;
  top: 72px;
  left: 72px;
  width: 140px;
  padding: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 120px;
  font-size: 20px;
  font-weight: 600;
  color: ${({ theme }) => theme.customized.colors.buttonsLinks};
  gap: 10px;

  background: none;
  border: 4px solid ${({ theme }) => theme.customized.colors.buttonsLinks};
  cursor: pointer;

  @media ${KIOSK_PRO_MEDIA.landscapeMaxWidth} {
    top: 52px;
    left: 52px;
  }

  @media ${KIOSK_PRO_MEDIA.portraitMaxWidth} {
    top: 56px;
    left: 56px;
  }
`;
